import { memo } from "react";
import { Link } from "react-router-dom";

import styled from "styled-components";

import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";

import { LoginErrorMessage as Message } from "./Message";

// -----------------------------------------------------------------------------

export const LoginError = memo(function LoginError({
  errorMessage,
  reset,
}: Props) {
  return (
    <Container>
      <ErrorOutlineIcon color="error" />
      <Typography variant="body1">
        <Message errorMessage={errorMessage} />
      </Typography>
      <ReturnContainer>
        <Link
          to="#"
          onClick={(event) => {
            event.preventDefault();
            reset();
          }}
        >
          Return to login
        </Link>
      </ReturnContainer>
    </Container>
  );
});

// -----------------------------------------------------------------------------

const Container = styled(Box)`
  align-items: center;
  display: grid;
  grid-template-columns: auto 1fr;
  gap: 16px;
`;

const ReturnContainer = styled(Box)`
  grid-column: 1 / span 2;
  text-align: center;
`;

// -----------------------------------------------------------------------------

interface Props {
  errorMessage: string;
  reset: Function;
}
